import { Injectable } from '@angular/core';
import { ChangeControlDisplayDetails } from '../models/change-control-display-details';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { PreviousPhaseDetail } from '../models/previous-phase-detail';

@Injectable({
  providedIn: 'root',
})
export class ChangeControlDetailsService {
  constructor(private httpClient: HttpClient) {}

  // Change Control Details
  getChangeControlDetails = (
    changeControlNumber: string
  ): Observable<ChangeControlDisplayDetails> => {
    return this.httpClient.get<ChangeControlDisplayDetails>(
      ApiConstants.ChangeControl_Details_Api.replace(
        '{changeControlNumber}',
        changeControlNumber
      )
    );
  };

  downloadFile(fileId: string)
    : Observable<any> {
    return this.httpClient.get(ApiConstants.Files_Download_Api + `${fileId}`);
  }
  
  // To get the valid phases Change control can be moved to previous phases
  getValidPreviousPhasesForChangeControl = (ChangeControlNumber: string) : Observable<any> => {
    return this.httpClient.get(ApiConstants.ChangeControl_ValidPreviousPhases_Api.replace("{ChangeControlNumber}", ChangeControlNumber));
  };
  
  // Update the Phase to one of the Valid Previous Phases
  MoveChangeControlToPreviousPhase = (previousPhaseDetail: PreviousPhaseDetail) : Observable<any> => {
    return this.httpClient.put(ApiConstants.ChangeControl_MoveToPreviousPhases_Api, previousPhaseDetail);
  }

  moveToNextPhase(number: string): Observable<ChangeControlDisplayDetails> {
    return this.httpClient.put<ChangeControlDisplayDetails>(
      ApiConstants.ChangeControl_MoveToNextPhase_Api.replace("{Number}", number),{}
    );
  }

moveChangeControlToVoided(number: string, reason: string): Observable<any> {
  return this.httpClient.put(
    ApiConstants.ChangeControl_MoveToVoidedPhase_Api.replace("{number}", number),
    JSON.stringify(reason),
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

  validateNextPhaseMovementFromImplementation(number: string){
    return this.httpClient.get(ApiConstants.ChangeControl_MoveToNextPhase_FromImplementation_Api.replace("{Number}", number));
  }

  exportToPDF(changeControlNumber: string): Observable<any> {
    const url = `${ApiConstants.ChangeControl_ExportToPDF_Api}/${changeControlNumber}`;
    return this.httpClient.get(url);
  }
}
